import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
    class: "px-4 py-3 bg-white border-t",
    style: { "border-color": "#e5e7eb" }
};
const _hoisted_2 = {
    key: 0,
    class: "mb-2"
};
const _hoisted_3 = { class: "flex items-center gap-2 px-3 py-2 text-xs text-gray-600 rounded-lg bg-gray-50" };
const _hoisted_4 = {
    key: 0,
    class: "w-3.5 h-3.5 border-2 border-eorange-400 border-t-transparent rounded-full animate-spin flex-shrink-0"
};
const _hoisted_5 = { class: "truncate max-w-[200px]" };
const _hoisted_6 = ["aria-label"];
const _hoisted_7 = { class: "flex items-center gap-2.5" };
const _hoisted_8 = { class: "relative flex-shrink-0 group" };
const _hoisted_9 = {
    class: "flex items-center justify-center transition-colors border rounded-full cursor-pointer w-9 h-9 hover:bg-gray-100",
    style: { "background-color": "#f5f6fa", "border-color": "#e5e7eb" }
};
const _hoisted_10 = { class: "absolute z-50 hidden mb-2 -translate-x-1/2 pointer-events-none bottom-full left-1/2 group-hover:block" };
const _hoisted_11 = { class: "px-3 py-2 text-xs text-center text-white bg-gray-800 rounded-lg shadow-lg whitespace-nowrap" };
const _hoisted_12 = { class: "font-medium" };
const _hoisted_13 = { class: "text-gray-300 mt-0.5" };
const _hoisted_14 = ["disabled", "placeholder", "onKeydown"];
const _hoisted_15 = ["disabled", "aria-label"];
import { ref } from "vue";
import { IconPaperclip, IconSend, IconX, IconCheck } from "@tabler/icons-vue";
import { useToast } from "vue-toastification";
import { useI18n } from "vue-i18n";
import { api } from "@infrastructure/api";
export default /*@__PURE__*/ _defineComponent({
    __name: 'MessageInput',
    props: {
        disabled: { type: Boolean },
        isSubmitting: { type: Boolean }
    },
    emits: ["send"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const toast = useToast();
        const { t } = useI18n();
        const text = ref("");
        const fileInputRef = ref(null);
        const pendingFileId = ref(null);
        const pendingFileName = ref("");
        const uploadState = ref(null);
        function autoResize(event) {
            const target = event.target;
            target.style.height = "auto";
            target.style.height = Math.min(target.scrollHeight, 128) + "px";
        }
        async function uploadToStorage(file) {
            const { data } = await api.post("/storage", {
                folder: "conversations",
                mimeType: file.type || "application/octet-stream",
                originalName: file.name,
            });
            const { id: storageId, uploadUrl } = data;
            await new Promise((resolve, reject) => {
                const xhr = new XMLHttpRequest();
                xhr.open("PUT", uploadUrl, true);
                xhr.setRequestHeader("Content-Type", file.type || "application/octet-stream");
                xhr.onload = () => xhr.status < 300
                    ? resolve()
                    : reject(new Error(`Upload failed: ${xhr.status}`));
                xhr.onerror = () => reject(new Error("Network error during upload"));
                xhr.send(file);
            });
            return String(storageId);
        }
        async function handleFileSelect(event) {
            const input = event.target;
            const file = input.files?.[0];
            if (!file)
                return;
            const allowedTypes = [
                "image/jpeg",
                "image/png",
                "image/gif",
                "image/webp",
                "video/mp4",
                "video/webm",
                "video/quicktime",
                "application/pdf",
                "application/msword",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                "application/vnd.ms-excel",
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            ];
            if (!allowedTypes.includes(file.type)) {
                toast.error(t("conversation.message_input.unsupported_file"));
                return;
            }
            if (file.size > 10 * 1024 * 1024) {
                toast.error(t("conversation.message_input.file_too_large"));
                return;
            }
            pendingFileName.value = file.name;
            uploadState.value = "uploading";
            pendingFileId.value = null;
            try {
                pendingFileId.value = await uploadToStorage(file);
                uploadState.value = "done";
            }
            catch {
                toast.error(t("conversation.message_input.upload_failed"));
                clearAttachment();
            }
            if (fileInputRef.value)
                fileInputRef.value.value = "";
        }
        function clearAttachment() {
            pendingFileId.value = null;
            pendingFileName.value = "";
            uploadState.value = null;
        }
        function handleSend() {
            if (props.disabled || props.isSubmitting)
                return;
            const payload = {};
            if (text.value.trim())
                payload.message = text.value.trim();
            if (pendingFileId.value)
                payload.file_id = pendingFileId.value;
            if (!payload.message && !payload.file_id)
                return;
            emit("send", payload);
            text.value = "";
            clearAttachment();
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (uploadState.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            (uploadState.value === 'uploading')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_4))
                                : (uploadState.value === 'done')
                                    ? (_openBlock(), _createBlock(_unref(IconCheck), {
                                        key: 1,
                                        class: "w-3.5 h-3.5 text-green-500 flex-shrink-0"
                                    }))
                                    : (_openBlock(), _createBlock(_unref(IconPaperclip), {
                                        key: 2,
                                        class: "w-3.5 h-3.5 flex-shrink-0"
                                    })),
                            _createElementVNode("span", _hoisted_5, _toDisplayString(pendingFileName.value), 1),
                            (uploadState.value !== 'uploading')
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 3,
                                    onClick: clearAttachment,
                                    class: "ml-auto text-gray-400 hover:text-gray-600",
                                    "aria-label": _unref(t)('conversation.message_input.clear_attachment')
                                }, [
                                    _createVNode(_unref(IconX), { class: "w-3.5 h-3.5" })
                                ], 8, _hoisted_6))
                                : _createCommentVNode("", true)
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("label", _hoisted_9, [
                            _createVNode(_unref(IconPaperclip), {
                                class: "w-4 h-4",
                                style: { "color": "#6b7280" }
                            }),
                            _createElementVNode("input", {
                                ref_key: "fileInputRef",
                                ref: fileInputRef,
                                type: "file",
                                accept: "image/jpeg,image/png,image/gif,image/webp,video/mp4,video/webm,video/quicktime,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                                class: "hidden",
                                onChange: handleFileSelect
                            }, null, 544)
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(t)("conversation.message_input.attach_file")), 1),
                                _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(t)("conversation.message_input.allowed_formats")), 1)
                            ]),
                            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "w-2 h-2 mx-auto -mt-1 rotate-45 bg-gray-800" }, null, -1))
                        ])
                    ]),
                    _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((text).value = $event)),
                        disabled: __props.disabled,
                        placeholder: _unref(t)('conversation.message_input.placeholder'),
                        rows: "1",
                        class: "flex-1 resize-none px-4 py-2 text-sm bg-[#F5F6FA] rounded-full focus:outline-none focus:ring-2 focus:ring-eorange-400 disabled:text-gray-400 overflow-y-auto",
                        style: { "height": "40px", "max-height": "128px" },
                        onKeydown: _withKeys(_withModifiers(handleSend, ["exact", "prevent"]), ["enter"]),
                        onInput: autoResize
                    }, null, 40, _hoisted_14), [
                        [_vModelText, text.value]
                    ]),
                    _createElementVNode("button", {
                        disabled: __props.disabled || (!text.value.trim() && !pendingFileId.value) || __props.isSubmitting,
                        onClick: handleSend,
                        class: "flex items-center justify-center flex-shrink-0 w-10 h-10 text-white transition-colors rounded-full disabled:opacity-40 disabled:cursor-not-allowed",
                        style: { "background-color": "#e8472a" },
                        "aria-label": _unref(t)('conversation.message_input.send')
                    }, [
                        _createVNode(_unref(IconSend), { class: "w-[18px] h-[18px]" })
                    ], 8, _hoisted_15)
                ])
            ]));
        };
    }
});
